// extracted by mini-css-extract-plugin
export default {"banner":"TopBanner_banner__vi5lT","bannerFullWidth":"TopBanner_bannerFullWidth__J3vPk"};